import { SVGProps } from 'react';

export const Sort = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.707 13.324L0.992351 9.60938L0 10.6017L4.707 15.3087L9.414 10.6017L8.42165 9.60938L4.707 13.324Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.707 0.691406L0 5.39841L0.992351 6.39076L4.707 2.67611L8.42165 6.39076L9.414 5.39841L4.707 0.691406Z"
      fill="currentColor"
    />
  </svg>
);
